<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Editar Natureza Fiscal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      loadingRegras: false,
      loadingCFOPs: false,
      submitNatuRegra: false,
      optionsDestino:[
        {
          'cod': 'AC',
          'desc': 'Acre',
        },
        {
          'cod': 'AL',
          'desc': 'Alagoas',
        },
        {
          'cod': 'AP',
          'desc': 'Amapá',
        },
        {
          'cod': 'AM',
          'desc': 'Amazonas',
        },
        {
          'cod': 'BA',
          'desc': 'Bahia',
        },
        {
          'cod': 'CE',
          'desc': 'Ceará',
        },
        {
          'cod': 'ES',
          'desc': 'Espírito Santo',
        },
        {
          'cod': 'GO',
          'desc': 'Goiás',
        },
        {
          'cod': 'MA',
          'desc': 'Maranhão',
        },
        {
          'cod': 'MT',
          'desc': 'Mato Grosso',
        },
        {
          'cod': 'MS',
          'desc': 'Mato Grosso do Sul',
        },
        {
          'cod': 'MG',
          'desc': 'Minas Gerais',
        },
        {
          'cod': 'PA',
          'desc': 'Pará',
        },
        {
          'cod': 'PB',
          'desc': 'Paraíba',
        },
        {
          'cod': 'PR',
          'desc': 'Paraná',
        },
        {
          'cod': 'PE',
          'desc': 'Pernambuco',
        },
        {
          'cod': 'PI',
          'desc': 'Piauí',
        },
        {
          'cod': 'RJ',
          'desc': 'Rio de Janeiro',
        },
        {
          'cod': 'RN',
          'desc': 'Rio Grande do Norte',
        },
        {
          'cod': 'RS',
          'desc': 'Rio Grande do Sul',
        },
        {
          'cod': 'RO',
          'desc': 'Rondônia',
        },
        {
          'cod': 'RR',
          'desc': 'Roraima',
        },
        {
          'cod': 'SC',
          'desc': 'Santa Catarina',
        },
        {
          'cod': 'SP',
          'desc': 'São Paulo',
        },
        {
          'cod': 'SE',
          'desc': 'Sergipe',
        },
        {
          'cod': 'TO',
          'desc': 'Tocantins',
        },
        {
          'cod': 'DF',
          'desc': 'Distrito Federal',
        },
      ],
      naturegraData: {
        icms: {},
        ipi: {},
        pis: {},
        cofins: {},
      },
      loadingNatureza: false,
      dtListPesqCFOP: null,
      dtListPesqProduto: null,
      dtListPesqProdutoIcms: null,
      dtListPesqProdutoIpi: null,
      dtListPesqProdutoPis: null,
      dtListPesqProdutoCofins: null,
      showModalRegra: false,
      errosValid: null,
      contClickAvanc: 0,
      naturezaData: {
        id: 0,
        status: 'I',
        ori: null,
        serie: null,
        tipo: null,
        regtrib: null,
        indpres: null,
      },
      natuRegrasData: [],
      enderecosData: {},
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,

      title: "Editar Natureza Fiscal",
      items: [
        {
          text: "Naturezas",
          href: "/naturezas/list",
        },
        {
          text: "Editar Natureza Fiscal",
          active: true,
        },
      ],
    };
  },
  validations: {
    naturezaData: {
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      serie: {
        required: helpers.withMessage("Campo série obrigatório, favor preencher.", required),
      },
      tipo: {
        required: helpers.withMessage("Campo Tipo obrigatório, favor preencher.", required),
      },
      regtrib: {
        required: helpers.withMessage("Campo código de regime tributário obrigatório, favor preencher.", required),
      },
      indpres: {
        required: helpers.withMessage("Campo indicador de presença obrigatório, favor preencher.", required),
      },
      ori: {
        required: helpers.withMessage("Campo origem obrigatório, favor preencher.", required),
      },
    },
    naturegraData: {
      icms: {
        cfop: {
          required: helpers.withMessage("Campo CFOP obrigatório, favor preencher.", required),
        },
      }
    }
  },
  methods: {
    redirecionarCfop(){
      console.log("redirect to cfop")

      let route = this.$router.resolve(`/cfop/list`)
      window.open(route.href, "_blank")
    },

    carregarDados() {
      this.updating = true
      console.log('carregarDados: ' + this.idData)
      let rota = this.$route.path
      // console.log(rota)
      let ultimaBarra = rota.lastIndexOf('/')
      if (ultimaBarra){
        this.idData = parseInt(rota.substring(ultimaBarra + 1))
      }
      if (this.idData > 0) {
        api.get(`${getBaseUrl()}api/natureza`, {
          params: { iddata: this.idData }
        }).then((res) => {
          this.naturezaData = res.data[0]
          this.natuRegrasData = res.data[1]

          if (this.naturezaData.ori === null) {
            this.naturezaData.ori = '0'
          }

          this.idData = this.naturezaData.id
          this.title = `Editar Natureza Fiscal (${this.naturezaData.id}) ${this.naturezaData.descricao}`
          this.updating = false
        });
      } else {
        this.title = `Criando Nova Natureza`
        this.updating = false
      }
    },

    formatDecimal(value) {
      if (value) {
        let value_n = parseFloat(value);
        return value_n.toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 4,
        });
      }
      return "0,00";
    },

    carregarRegras() {
      this.loadingRegras = true
      api.get(`${getBaseUrl()}api/naturegras`, {
        params: { iddata: this.idData }
      }).then((res) => {
        this.naturezaData = res.data[0]
        this.natuRegrasData = res.data[1]
        this.loadingRegras = false
      });
    },

    deletarRegra(iditem) {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingRegras = true
          api.delete(`${getBaseUrl()}api/naturegra`, {
            params: {
              'iddata': iditem
            }
          }).then(() => {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
              this.carregarRegras()
            })
          })
        }
      })
    },

    editarRegra(dataRegra) {
      this.naturegraData = this.natuRegrasData.find((regra) => {
        if (dataRegra.id === regra.id) {
          return regra
        }
      })

      this.dtListPesqCFOP = [
        {
          'codigo': this.naturegraData.icms.cfop,
          'descricao': this.naturegraData.icms.cfopdesc,
        }
      ]

      this.dtListPesqProdutoIcms = [
        {
          'codigo': this.naturegraData.icms.produto,
          'descricao': this.naturegraData.icms.descprod,
        }
      ]
      this.dtListPesqProdutoIpi = [
        {
          'codigo': this.naturegraData.ipi.produto,
          'descricao': this.naturegraData.ipi.descprod,
        }
      ]
      this.dtListPesqProdutoPis = [
        {
          'codigo': this.naturegraData.pis.produto,
          'descricao': this.naturegraData.pis.descprod,
        }
      ]
      this.dtListPesqProdutoCofins = [
        {
          'codigo': this.naturegraData.cofins.produto,
          'descricao': this.naturegraData.cofins.descprod,
        }
      ]

      this.submitNatuRegra = false
      this.showModalRegra = true
    },

    novaRegra() {
      if (this.idData === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar a natureza antes de adicionar regra",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.naturegraData = {
          icms: {},
          ipi: {},
          pis: {},
          cofins: {},
          issqn: {},
        }
        this.submitNatuRegra = false
        this.showModalRegra = true
      }
    },

    confirmarRegra() {
      this.submitNatuRegra = true
      this.v$.naturegraData.$touch()

      if (!this.v$.naturegraData.$invalid) {
        this.updating = true
        api.post(`${getBaseUrl()}api/naturegra`, {
          natureza_id: this.idData,
          naturezaData: this.naturezaData,
          naturegraData: this.naturegraData
        }).then((res) => {
          this.updating = false
          if (res.data !== false) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.showModalRegra = false
              this.carregarDados()
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Erro na atualização da regra!",
              showConfirmButton: false,
              timer: 1500
            })
          }
        }).catch((err) => {
          let erros = err.response.data.errors
          let listaErros = []
          Object.keys(erros).forEach(key => {
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor preencher os campos obrigatórios da regra",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    pesqCFOP(evt) {
      console.log('pesqCFOP')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.dtListPesqCFOP = null
        this.loadingCFOPs = true
        api.get(`${getBaseUrl()}api/pesqcfops`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCFOP = res.data
        })
      }
    },

    pesqProduto(tipo, evt) {
      console.log('pesqProduto')
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        console.log(evt)

        this.loadingCFOPs = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          switch (tipo) {
            case 'icms':
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProdutoIcms = res.data
              break
            case 'ipi':
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProdutoIpi = res.data
              break
            case 'pis':
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProdutoPis = res.data
              break
            case 'cofins':
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProdutoCofins = res.data
              break
            default:
              console.log(`tipo selected ${tipo}`)
              this.dtListPesqProduto = res.data
              break
          }
        })
      }
    },

    salvar() {
      this.submitted = true;
      this.v$.naturezaData.$touch()
      if (!this.v$.naturezaData.$invalid) {
        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/natureza`, {
          naturezaData: this.naturezaData
        }).then((res) => {
          this.naturezaData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          if (this.idData === 0) {
            this.$router.replace({ path: `/natureza/editar/${this.naturezaData.id}` })
            this.idData = this.naturezaData.id
          }

        }).catch((err) => {
          let erros = err.response.data.errors
          let listaErros = []
          Object.keys(erros).forEach(key => {
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor preencher os campos obrigatórios da natureza",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
  },
  mounted() {
    this.carregarDados()
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <div class="row" v-if="!updating" >

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="salvar">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novaRegra">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Nova Regra de Imposto
              </b-button>

<!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="imprimirOrcamento">-->
<!--                <i class="bx bx-printer font-size-16 align-middle me-2"></i>-->
<!--                Imprimir-->
<!--              </b-button>-->

<!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento">-->
<!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
<!--                Copiar-->
<!--              </b-button>-->

<!--              <b-button variant="outline-danger" class="mx-2" @click="cancelarOrcamento" :disabled="orctoData.status !== 'EL'" v-if="orctoData.status === 'EL'">-->
<!--                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>-->
<!--                Cancelar Orçamento-->
<!--              </b-button>-->



              <!--                    <span-->
              <!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-cash"></i>-->
              <!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

<!--              <button class="btn btn-success"-->
<!--                      @click="confirmarOrcamento"-->
<!--                      :disabled="orctoData.status !== 'EL'"-->
<!--                      v-if="orctoData.status === 'EL' && orctoItensData && orctoItensData.length > 0">-->
<!--                <i class="mdi mdi-rocket-launch me-1 text-end"></i> SUCESSO!-->
<!--              </button>-->


            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="checkout-tabs" v-if="!updating">

      <b-card-text>
        <div class="card">
          <div class="card-body">
<!--            <h4 class="card-title">Informações Principais</h4>-->
<!--            <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

            <form class="needs-validation">
              <div class="row">

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="descricao">Descrição</label>
                    <input
                        id="descricao"
                        v-model="naturezaData.descricao"
                        type="text"
                        class="form-control"
                        placeholder="Descrição"
                        maxlength="60"
                      :class="{ 'is-invalid': (submitted || v$.naturezaData.descricao.$dirty) && v$.naturezaData.descricao.$error, }" />
                    <div v-if="(submitted || v$.naturezaData.descricao.$dirty) && v$.naturezaData.descricao.$error"
                         class="invalid-feedback">
                      <span v-if="v$.naturezaData.descricao.required.$message">{{ v$.naturezaData.descricao.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="serie">Série</label>
                    <input id="serie" v-model="naturezaData.serie" type="text" class="form-control" placeholder="Série"
                      maxlength="3"
                      :class="{ 'is-invalid': (submitted || v$.naturezaData.serie.$dirty) && v$.naturezaData.serie.$error, }" />
                    <div v-if="(submitted || v$.naturezaData.serie.$dirty) && v$.naturezaData.serie.$error"
                      class="invalid-feedback">
                      <span v-if="v$.naturezaData.serie.required.$message">{{ v$.naturezaData.serie.required.$message
                        }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="tipo">Tipo</label>
                    <select
                        id="tipo"
                        v-model="naturezaData.tipo"
                        class="form-control"
                      :class="{ 'is-invalid': (submitted || v$.naturezaData.tipo.$dirty) && v$.naturezaData.tipo.$error, }">
                      <option value="EN">Entrada</option>
                      <option value="SA">Saída</option>
                    </select>
                    <div v-if="(submitted || v$.naturezaData.tipo.$dirty) && v$.naturezaData.tipo.$error"
                      class="invalid-feedback">
                      <span v-if="v$.naturezaData.tipo.required.$message">{{ v$.naturezaData.tipo.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="regtrib">Código Regime Tributário</label>
                    <select
                        id="regtrib"
                        v-model="naturezaData.regtrib"
                        class="form-control"
                      :class="{ 'is-invalid': (submitted || v$.naturezaData.regtrib.$dirty) && v$.naturezaData.regtrib.$error, }">
                      <option value="1">1 - Simples Nacional</option>
                      <option value="2">2 - Simples Nacional - excesso de sublimite de receita bruta</option>
                      <option value="3">3 - Regime Normal</option>
                      <option value="4">4 - Simples Nacional - Microempreendedor Individual - MEI</option>
                    </select>
                    <div v-if="(submitted || v$.naturezaData.regtrib.$dirty) && v$.naturezaData.regtrib.$error"
                      class="invalid-feedback">
                      <span v-if="v$.naturezaData.regtrib.required.$message">{{ v$.naturezaData.regtrib.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="indpres">Indicador de Presença</label>
                    <select
                        id="indpres"
                        v-model="naturezaData.indpres"
                        class="form-control"
                      :class="{ 'is-invalid': (submitted || v$.naturezaData.indpres.$dirty) && v$.naturezaData.indpres.$error, }">
                      <option value="0">0 - Não se Aplica</option>
                      <option value="1">1 - Operação Presencial</option>
                      <option value="2">2 - Operação Não Presencial, pela Internet</option>
                      <option value="3">3 - Operação Não Presencial, Teleatendimento</option>
                      <option value="4">4 - NFC-e em Operação com Entrega em Domicílio</option>
                      <option value="5">5 - Operação Presencial, Fora do Estabelecimento</option>
                      <option value="9">9 - Operação Presencial, Outros</option>
                    </select>
                    <div v-if="(submitted || v$.naturezaData.indpres.$dirty) && v$.naturezaData.indpres.$error"
                      class="invalid-feedback">
                      <span v-if="v$.naturezaData.indpres.required.$message">{{ v$.naturezaData.indpres.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="finnfe">Tipo emissão</label>
                    <select
                        id="finnfe"
                        v-model="naturezaData.finnfe"
                        class="form-control">
                      <option value="1" selected>1 - Nota normal</option>
                      <option value="2">2 - Nota complementar</option>
                      <option value="3">3 - Nota de ajuste</option>
                      <option value="4">4 - Devolução de mercadoria</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="ori">Origem itens</label>
                    <select
                        id="ori"
                        v-model="naturezaData.ori"
class="form-control"
                      :class="{ 'is-invalid': (submitted || v$.naturezaData.ori.$dirty) && v$.naturezaData.ori.$error, }">
                      <option value="0">0 - nacional</option>
                        <option value="1">1 - estrangeira (importação direta)</option>
                        <option value="2">2 - estrangeira (adquirida no mercado interno)</option>
                        <option value="3">3 - nacional com mais de 40% de conteúdo estrangeiro</option>
                        <option value="4">4 - nacional produzida através de processos produtivos básicos</option>
                        <option value="5">5 - nacional com menos de 40% de conteúdo estrangeiro</option>
                        <option value="6">6 - estrangeira (importação direta) sem produto nacional similar</option>
                        <option value="7">7 - estrangeira (adquirida no mercado interno) sem produto nacional similar</option>
                        <option value="8">8 - nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%</option>
                    </select>
                    <div v-if="(submitted || v$.naturezaData.ori.$dirty) && v$.naturezaData.ori.$error"
                      class="invalid-feedback">
                      <span v-if="v$.naturezaData.ori.required.$message">{{ v$.naturezaData.ori.required.$message
                        }}</span>
                    </div>
                  </div>
                </div>


                <div class="col-sm-1 mx-4">
                  <div class="mb-3 align-items-end align-content-start float-start">
                    <h5 class="font-size-14">Consumidor</h5>
                    <b-form-checkbox
                        switch size="lg"
                        value="S"
                        unchecked-value="N"
                        v-model="naturezaData.consfinal">
                      Final
                    </b-form-checkbox>
                  </div>
                </div>

                <!--<div class="col-sm-1 mx-4">
                  <div class="mb-3 align-items-end align-content-end float-end">
                    <h5 class="font-size-14">Operação de</h5>
                    <b-form-checkbox
                        switch size="lg"
                        value="S"
                        unchecked-value="N"
                        v-model="naturezaData.devolucao">
                      Devolução
                    </b-form-checkbox>
                  </div>
                </div>-->


                <div class="col-sm-1">
                  <div class="mb-3 align-items-end align-content-end float-end">
                    <h5 class="font-size-14">Status</h5>
                    <b-form-checkbox
                        switch size="lg"
                        value="A"
                        unchecked-value="I"
                        v-model="naturezaData.status">
                      {{ naturezaData.status === 'A' ? 'Ativo' : 'Inativo' }}
                    </b-form-checkbox>
                  </div>
                </div>


              </div>


              <div class="row">

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="obsc">Informações Adicionais (Complementares)</label>
                    <textarea
                        id="obsc"
                        v-model="naturezaData.obs"
                        type="text"
                        rows="3"
                        class="form-control"
                        placeholder="Informações Adicionais"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="obsf">Informações Adicionais (Interesse Fisco)</label>
                    <textarea
                        id="obsf"
                        v-model="naturezaData.obsfisco"
                        type="text"
                        rows="3"
                        class="form-control"
                        placeholder="Informações Adicionais "/>
                  </div>
                </div>

              </div>
            </form>

          </div>
        </div>
      </b-card-text>



      <b-card-text>
        <div class="card">
          <div class="card-body">
            <div class="card shadow-none border mb-0">
              <div class="card-body">
                <h4 class="card-title mb-4">Regras de Tributação</h4>
                <div class="row" v-if="loadingRegras">
                  <div class="col-12 text-center">
                    <b-spinner type="grow"
                               class="m-6 mx-2"
                               variant="secondary"
                               role="status">
                    </b-spinner>
                    <b-spinner type="grow"
                               class="m-6 mx-2"
                               variant="secondary"
                               role="status">
                    </b-spinner>
                    <b-spinner type="grow"
                               class="m-6 mx-2"
                               variant="secondary"
                               role="status">
                    </b-spinner>
                  </div>
                </div>



                <b-tabs pills justified content-class="p-3 text-muted" v-if="!loadingRegras">
                  <b-tab active class="border-0">
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">ICMS</span>
                    </template>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">CFOP</th>
                          <th scope="col">Destino</th>
                          <th scope="col">Produto(Cód.)</th>
                          <th scope="col">Produto</th>
                          <th scope="col">Cód. tributário</th>
                          <th scope="col">Alíquota</th>
                        </tr>
                        </thead>
                        <tbody>

                          <tr v-for="data in natuRegrasData" :key="data.id">








 
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.icms.cfop }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.icms?.destinoform?.join(', ') || null }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.icms.produto }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.icms.descprod }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.icms.codsit }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ formatDecimal(data.icms.aliqicms) }}%
                              </span>
                            </h5>
                          </td>
                        

                          <td>
                            <div class="button-items">
                                <b-button variant="outline-warning" @click="editarRegra(data)"
                                  :disabled="data.email === 'admin@admin.com.br'">








 
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>

                              <b-button variant="outline-danger" @click="deletarRegra(data.id)" :disabled="data.email === 'admin@admin.com.br'">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">IPI</span>
                    </template>
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Produto(Cód.)</th>
                          <th scope="col">Produto</th>
                          <th scope="col">Cód. Tributário</th>
                          <th scope="col">Alíquota</th>
                          <th scope="col">Base Percentual</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr v-for="data in natuRegrasData" :key="data.id">
                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                              </h5>
                            </td>
                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.ipi.produto }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.ipi.descprod }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.ipi.codsit }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDecimal(data.ipi.aliqipi) }}%
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDecimal(data.ipi.baseperc) }}%
                                </span>
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-envelope"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">PIS</span>
                    </template>
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Produto(Cód.)</th>
                          <th scope="col">Produto</th>
                          <th scope="col">Cód. Tributário</th>
                          <th scope="col">Alíquota</th>
                          <th scope="col">Base Percentual</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr v-for="data in natuRegrasData" :key="data.id">
                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                              </h5>
                            </td>


                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.pis.produto }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.pis.descprod }}
                                </span>
                              </h5>
                            </td>


                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.pis.codsit }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDecimal(data.pis.aliqpis) }}%
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDecimal(data.pis.baseperc) }}%
                                </span>
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>


                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">COFINS</span>
                    </template>
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Produto(Cód.)</th>
                          <th scope="col">Produto</th>
                          <th scope="col">Cód. Tributário</th>
                          <th scope="col">Alíquota</th>
                          <th scope="col">Base Percentual</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr v-for="data in natuRegrasData" :key="data.id">
                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                              </h5>
                            </td>
                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.cofins.produto }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.cofins.descprod }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.cofins.codsit }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDecimal(data.cofins.aliqcofins) }}%
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDecimal(data.cofins.baseperc) }}%
                                </span>
                              </h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </b-card-text>
    </div>



    <b-modal
      :title="naturegraData.id != null ? `Editar Regra de Imposto (${naturegraData.id})` : 'Criar Nova Regra de Imposto'"
      v-model="showModalRegra" hide-footer>
      <b-tabs pills justified content-class="p-3 text-muted">
        <b-tab active class="border-0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">ICMS</span>
          </template>
          <div class="row">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="col-md-12">
                  <div class="mb-3">
                    <span>Quando for para </span>
                    <multiselect v-model="naturegraData.icms.destinoform"
                                :mode="'tags'"
                                :options="optionsDestino"
                                placeholder="Qualquer estado"
                                label="cod"
                                track-by="cod"
                                value-prop="cod">
                      <template #option="slotProps">
                        <div style="min-width: 50px;">
                      <span class="text-info">
                        {{ slotProps.option.cod }}
                      </span>
                        </div>
                        <div style="min-width: 300px;">
                      <span class="mx-4" >
                        {{ slotProps.option.desc }}
                      </span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>


                <div class="col-md-12">
                  <div class="mb-3">
                    <span>Quando for</span>
                    <multiselect @search-change="(evt) => pesqProduto('icms', evt)"
v-model="naturegraData.icms.produto"
                                placeholder="Qualquer produto"
                                :options="dtListPesqProdutoIcms"
                                :searchable="true"
                                label="descricao"
                                track-by="descricao"
                                value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                      <span class="text-info">
                        {{ slotProps.option.codigo }}
                      </span>
                            <span class="mx-4" >
                        {{ slotProps.option.descricao }}
                      </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h5 class="card-title">Definições da Regra de Tributação</h5>
          <div class="row">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="codsit">Código Situação Operação Simples Nacional (CSOSN):  </label>
                    <select
                        id="codsit"
v-model="naturegraData.icms.codsit"
                        class="form-control">
                      <option value="101">101 - Tributada com permissão de crédito</option>
                      <option value="102">102 - Tributada sem permissão de crédito</option>
                      <option value="103">103 - Isenção do ICMS para faixa de receita bruta</option>
                      <option value="201">201 - Tributada com permissão de crédito e com cobrança do ICMS por ST</option>
                      <option value="202">202 - Tributada sem permissão de crédito e com cobrança do ICMS por ST</option>
                      <option value="203">203 - Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por ST</option>
                      <option value="300">300 - Imune</option>
                      <option value="400">400 - Não tributada</option>
                      <option value="500">500 - ICMS cobrado anteriormente por ST ou por antecipação</option>
                      <option value="900">900 - Outros</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="codtribicms">Situação tributária(*)</label>
                    <select id="codtribicms" class="form-control" v-model="naturegraData.icms.codtrib">
                        <option value="00">00 - tributada integralmente</option>
                        <option value="02">02 - tributação monofásica própria sobre combustíveis</option>
                        <option value="10">10 - tributada e com cobrança do ICMS por substituição tributária</option>
                        <option value="10_partilha">10_partilha - tributada e com cobrança do ICMS por substituição tributária. Operação interestadual para consumidor final com partilha do ICMS devido na operação entre a UF de origem e a do destinatário, ou a UF definida na legislação. (Ex. UF da concessionária de entrega do veículo)</option>
                        <option value="15">15 - tributação monofásica própria e com responsabilidade pela retenção sobre combustíveis</option>
                        <option value="20">20 - tributada com redução de base de cálculo</option>
                        <option value="30">30 - isenta ou não tributada e com cobrança do ICMS por substituição tributária</option>
                        <option value="40">40 - isenta</option>
                        <option value="41">41 - não tributada</option>
                        <option value="41_st">41_st - não tributada com ICMS ST devido para a UF de destino, nas operações interestaduais de produtos que tiveram retenção antecipada de ICMS por ST na UF do remetente. Repasse via Substituto Tributário.</option>
                        <option value="50">50 - suspensão</option>
                        <option value="51">51 - diferimento (a exigência do preenchimento das informações do ICMS diferido fica a critério de cada UF)</option>
                        <option value="53">53 - tributação monofásica sobre combustíveis com recolhimento diferido</option>
                        <option value="60">60 - cobrado anteriormente por substituição tributária</option>
                        <option value="60_st">60_st - cobrado anteriormente por substituição tributária com ICMS ST devido para a UF de destino, nas operações interestaduais de produtos que tiveram retenção antecipada de ICMS por ST na UF do remetente. Repasse via Substituto Tributário.</option>
                        <option value="61">61 - tributação monofásica sobre combustíveis cobrada anteriormente</option>
                        <option value="70">70 - tributada com redução de base de cálculo e com cobrança do ICMS por substituição tributária</option>
                        <option value="90">90 - outras (regime Normal)</option>
                        <option value="90_partilha">90_partilha - outras (regime Normal). Operação interestadual para consumidor final com partilha do ICMS devido na operação entre a UF de origem e a do destinatário, ou a UF definida na legislação. (Ex. UF da concessionária de entrega do veículo)</option>
                        <option value="101">101 - tributada pelo Simples Nacional com permissão de crédito</option>
                        <option value="102">102 - tributada pelo Simples Nacional sem permissão de crédito</option>
                        <option value="103">103 - isenção do ICMS no Simples Nacional para faixa de receita bruta</option>
                        <option value="201">201 - tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária</option>
                        <option value="202">202 - tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária</option>
                        <option value="203">203 - isenção do ICMS nos Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária</option>
                        <option value="300">300 - imune</option>
                        <option value="400">400 - não tributada pelo Simples Nacional</option>
                        <option value="500">500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação</option>
                        <option value="900">900 - outras (regime Simples Nacional)</option>
                    </select>
                  </div>
                </div>


                <div class="col-md-12">
                  <div class="mb-3">
                    <span>CFOP <i @click="redirecionarCfop" class="bx bx-link-external font-size-16 align-middle me-3" style="cursor:pointer;" title="Acessar CFOP"></i></span>
                    <multiselect id="cfop"
                                @search-change="pesqCFOP"
v-model="naturegraData.icms.cfop"
                                placeholder="Pesquisar CFOP"
                                :options="dtListPesqCFOP"
                                :searchable="true"
                                label="descricao"
                                track-by="descricao"
value-prop="codigo"
                      :class="{ 'is-invalid': (submitNatuRegra || v$.naturegraData.icms.cfop.$dirty) && v$.naturegraData.icms.cfop.$error, }">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                            <span class="mx-4" >
                              {{ slotProps.option.descricao }}
                              </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                    <div
                      v-if="(submitNatuRegra || v$.naturegraData.icms.cfop.$dirty) && v$.naturegraData.icms.cfop.$error"
                      class="invalid-feedback" style="display: block;">
                      <span v-if="v$.naturegraData.icms.cfop.required.$message">{{
                        v$.naturegraData.icms.cfop.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="aliqicms">Alíquota ICMS (%)</label>
                      <input
                          id="aliqicms"
v-model="naturegraData.icms.aliqicms"
                          type="number"
                          class="form-control text-end"
                          placeholder="Alíquota ICMS (%)"/>
                    </div>
                  </div>

                  <div class="col-6">
                    <div class="mb-3">
                      <label for="aliqcred">Alíquota Aplicável Crédito</label>
                      <input
                          id="aliqcred"
v-model="naturegraData.icms.aliqcred"
                          type="number"
                          class="form-control text-end"
                          placeholder="Alíquota Aplicável Crédito"/>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-6">
                    <div class="mb-3">
                      <label for="aliqfcp">Alíquota FCP (%)</label>
                      <input
                          id="aliqfcp"
v-model="naturegraData.icms.aliqfcp"
                          type="number"
                          class="form-control text-end"
                          placeholder="Alíquota FCP (%)"/>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>



        </b-tab>
        <!--end of icms data-->


        <!--begining of ipi data-->
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">IPI</span>
          </template>
          
          <div class="row">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="col-md-12">
                  <div class="mb-3">
                    <span>Quando produto for</span>
                    <multiselect @search-change="(evt) => pesqProduto('ipi', evt)"
v-model="naturegraData.ipi.produto"
                                placeholder="Qualquer produto"
                                :options="dtListPesqProdutoIpi"
                                :searchable="true"
                                label="descricao"
                                track-by="descricao"
                                value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                      <span class="text-info">
                        {{ slotProps.option.codigo }}
                      </span>
                            <span class="mx-4" >
                        {{ slotProps.option.descricao }}
                      </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="codipisit">Código Situação tributária (IPI):  </label>
                    <select
                        id="codipisit"
v-model="naturegraData.ipi.codsit"
                        class="form-control">
                      <option value="null">Sem IPI</option>
                      <option value="50">50 - Saída tributada</option>
                      <option value="51">51 - Saída tributada com alíquota zero</option>
                      <option value="52">52 - Saída isenta</option>
                      <option value="53">53 - Saída não-tributada</option>
                      <option value="54">54 - Saída imune</option>
                      <option value="55">55 - Saída com suspensão</option>
                      <option value="99">99 - Outras saídas</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="aliqipi">Alíquota IPI (%)</label>
                <input
                    id="aliqipi"
v-model="naturegraData.ipi.aliqipi"
                    type="number"
                    class="form-control text-end"
                    placeholder="Alíquota IPI (%)"/>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="baseipi">Base IPI (%)</label>
                <input
                    id="baseipi"
v-model="naturegraData.ipi.baseperc"
                    type="number"
                    class="form-control text-end"
                    placeholder="Base IPI (%)"/>
              </div>
            </div>
          </div>
        </b-tab>
        <!--end of ipi data-->


        <!--beginig of pis data-->
        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-envelope"></i>
            </span>
            <span class="d-none d-sm-inline-block">PIS</span>
          </template>
          <div class="row">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="col-md-12">
                  <div class="mb-3">
                    <span>Quando produto for</span>
                    <multiselect @search-change="(evt) => pesqProduto('pis', evt)"
v-model="naturegraData.pis.produto"
                                placeholder="Qualquer produto"
                                :options="dtListPesqProdutoPis"
                                :searchable="true"
                                label="descricao"
                                track-by="descricao"
                                value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                      <span class="text-info">
                        {{ slotProps.option.codigo }}
                      </span>
                            <span class="mx-4" >
                        {{ slotProps.option.descricao }}
                      </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="codpissit">Código Situação tributária (PIS):  </label>
                    <select
                        id="codpissit"
v-model="naturegraData.pis.codsit"
                        class="form-control">
                      <option value="49">49 - Outras operações de saída</option>
                      <option value="50">50 - Op. com direito a crédito: Vinculada exclusivamente a receita tributada no mercado interno </option>
                      <option value="51">51 - Op. com direito a crédito: Vinculada exclusivamente a receita NÃO tributada no mercado interno </option>
                      <option value="52">52 - Op. com direito a crédito: Vinculada exclusivamente a receita de exportação </option>
                      <option value="53">53 - Op. com direito a crédito: Vinculada a receitas tributadas e NÃO tributadas no mercado interno </option>
                      <option value="54">54 - Op. com direito a crédito: Vinculada a receitas tributadas no mercado interno e de exportação </option>
                      <option value="55">55 - Op. com direito a crédito: Vinculada a receitas NÃO tributadas no mercado interno e de exportação </option>
                      <option value="56">56 - Op. com direito a crédito: Vinculada a receitas tributadas e NÃO no mercado interno e de exportação </option>
                      <option value="60">60 - Crédito presumido: Op. de aquisição vinculada exclusivamente a receita tributada no mercado interno </option>
                      <option value="61">61 - Crédito presumido: Op. de aquisição vinculada exclusivamente a receita NÃO tributada no mercado interno </option>
                      <option value="62">62 - Crédito presumido: Op. de aquisição vinculada exclusivamente a receita de exportação </option>
                      <option value="63">63 - Crédito presumido: Op. de aquisição vinculada a receitas tributadas e NÃO tributadas no mercado interno </option>
                      <option value="64">64 - Crédito presumido: Op. de aquisição vinculada a receitas tributadas no mercado interno e de exportação </option>
                      <option value="65">65 - Crédito presumido: Op. de aquisição vinculada a receitas NÃO tributadas no mercado interno e de exportação </option>
                      <option value="66">66 - Crédito presumido: Op. de aquisição vinculada a receitas tributadas e NÃO tributadas no mercado interno e de exportação </option>
                      <option value="67">67 - Crédito presumido: Outras operações </option>
                      <option value="70">70 - Operações de aquisição sem direito a crédito </option>
                      <option value="71">71 - Operações de aquisição com isenção </option>
                      <option value="72">72 - Operações de aquisição com suspensão </option>
                      <option value="73">73 - Operações de aquisição a alíquota zero </option>
                      <option value="74">74 - Operações de aquisição sim incidência da contribuição </option>
                      <option value="75">75 - Operações de aquisição por substituição tributária </option>
                      <option value="98">98 - Outras operações de entrada </option>
                      <option value="99">99 - Outras operações </option>
                      <option value="01">01 - Operação tributável (alíquota normal, cumulativo ou não) </option>
                      <option value="02">02 - Operação tributável (alíquota diferenciada) </option>
                      <option value="03">03 - Operação tributável (alíquota por unidade de produto) </option>
                      <option value="04">04 - Operação tributável (tributação monofásica, alíquota zero) </option>
                      <option value="05">05 - Operação tributável (substituição tributária) </option>
                      <option value="06">06 - Operação tributável (alíquota zero) </option>
                      <option value="07">07 - Operação isenta da cotribuição </option>
                      <option value="08">08 - Operação sem incidência da contribuição </option>
                      <option value="09">09 - Operação com suspensão da cotribuição </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="aliqpis">Alíquota PIS (%)</label>
                <input
                    id="aliqpis"
v-model="naturegraData.pis.aliqpis"
                    type="number"
                    class="form-control text-end"
                    placeholder="Alíquota PIS (%)"/>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="basepis">Base PIS (%)</label>
                <input
                    id="basepis"
v-model="naturegraData.pis.baseperc"
                    type="number"
                    class="form-control text-end"
                    placeholder="Base PIS (%)"/>
              </div>
            </div>
          </div>
        </b-tab>
        <!--end of pis data-->


        <b-tab>
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-cog"></i>
            </span>
            <span class="d-none d-sm-inline-block">COFINS</span>
          </template>
          <div class="row">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="col-md-12">
                  <div class="mb-3">
                    <span>Quando produto for</span>
                    <multiselect @search-change="(evt) => pesqProduto('cofins', evt)"
                      v-model="naturegraData.cofins.produto"
                                placeholder="Qualquer produto"
                                :options="dtListPesqProdutoCofins"
                                :searchable="true"
                                label="descricao"
                                track-by="descricao"
                                value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                      <span class="text-info">
                        {{ slotProps.option.codigo }}
                      </span>
                            <span class="mx-4" >
                        {{ slotProps.option.descricao }}
                      </span>
                          </div>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="codcofinscodsit">Código Situação tributária (COFINS):  </label>
                    <select
                        id="codcofinscodsit"
v-model="naturegraData.cofins.codsit"
                        class="form-control">
                      <option value="49">49 - Outras operações de saída</option>
                      <option value="50">50 - Op. com direito a crédito: Vinculada exclusivamente a receita tributada no mercado interno </option>
                      <option value="51">51 - Op. com direito a crédito: Vinculada exclusivamente a receita NÃO tributada no mercado interno </option>
                      <option value="52">52 - Op. com direito a crédito: Vinculada exclusivamente a receita de exportação </option>
                      <option value="53">53 - Op. com direito a crédito: Vinculada a receitas tributadas e NÃO tributadas no mercado interno </option>
                      <option value="54">54 - Op. com direito a crédito: Vinculada a receitas tributadas no mercado interno e de exportação </option>
                      <option value="55">55 - Op. com direito a crédito: Vinculada a receitas NÃO tributadas no mercado interno e de exportação </option>
                      <option value="56">56 - Op. com direito a crédito: Vinculada a receitas tributadas e NÃO no mercado interno e de exportação </option>
                      <option value="60">60 - Crédito presumido: Op. de aquisição vinculada exclusivamente a receita tributada no mercado interno </option>
                      <option value="61">61 - Crédito presumido: Op. de aquisição vinculada exclusivamente a receita NÃO tributada no mercado interno </option>
                      <option value="62">62 - Crédito presumido: Op. de aquisição vinculada exclusivamente a receita de exportação </option>
                      <option value="63">63 - Crédito presumido: Op. de aquisição vinculada a receitas tributadas e NÃO tributadas no mercado interno </option>
                      <option value="64">64 - Crédito presumido: Op. de aquisição vinculada a receitas tributadas no mercado interno e de exportação </option>
                      <option value="65">65 - Crédito presumido: Op. de aquisição vinculada a receitas NÃO tributadas no mercado interno e de exportação </option>
                      <option value="66">66 - Crédito presumido: Op. de aquisição vinculada a receitas tributadas e NÃO tributadas no mercado interno e de exportação </option>
                      <option value="67">67 - Crédito presumido: Outras operações </option>
                      <option value="70">70 - Operações de aquisição sem direito a crédito </option>
                      <option value="71">71 - Operações de aquisição com isenção </option>
                      <option value="72">72 - Operações de aquisição com suspensão </option>
                      <option value="73">73 - Operações de aquisição a alíquota zero </option>
                      <option value="74">74 - Operações de aquisição sim incidência da contribuição </option>
                      <option value="75">75 - Operações de aquisição por substituição tributária </option>
                      <option value="98">98 - Outras operações de entrada </option>
                      <option value="99">99 - Outras operações </option>
                      <option value="01">01 - Operação tributável (alíquota normal, cumulativo ou não) </option>
                      <option value="02">02 - Operação tributável (alíquota diferenciada) </option>
                      <option value="03">03 - Operação tributável (alíquota por unidade de produto) </option>
                      <option value="04">04 - Operação tributável (tributação monofásica, alíquota zero) </option>
                      <option value="05">05 - Operação tributável (substituição tributária) </option>
                      <option value="06">06 - Operação tributável (alíquota zero) </option>
                      <option value="07">07 - Operação isenta da cotribuição </option>
                      <option value="08">08 - Operação sem incidência da contribuição </option>
                      <option value="09">09 - Operação com suspensão da cotribuição </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="aliqcofins">Alíquota COFINS (%)</label>
                <input
                    id="aliqcofins"
v-model="naturegraData.cofins.aliqcofins"
                    type="number"
                    class="form-control text-end"
                    placeholder="Alíquota COFINS (%)"/>
              </div>
            </div>

            <div class="col-6">
              <div class="mb-3">
                <label for="basecofins">Base COFINS (%)</label>
                <input
                    id="basecofins"
v-model="naturegraData.cofins.baseperc"
                    type="number"
                    class="form-control text-end"
                    placeholder="Base COFINS (%)"/>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <!--end of cofins data-->


      <div class="row" v-if="loadingNatureza">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingNatureza && naturegraData">
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalRegra = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarRegra">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

  </Layout>
</template>
